import * as _ from 'lodash-es';
import { Delta } from 'quill/core';
import { parseHeaderId } from '../formats/HeaderId';
import getHeaderTitle from '../utils/getHeaderTitle';

function prepareContentForCard(delta: Delta, anchor?: string): Delta {
  let content = new Delta();

  let anchorIndex: number | null = null;
  const anchorHeaderId = anchor ? parseHeaderId(anchor) : null;

  delta.eachLine((line, attributes, index) => {
    if (attributes['header-id'] === anchorHeaderId) {
      anchorIndex = index;
    }

    if (index === 0) {
      if (anchor) {
        const headerTitle = getHeaderTitle(delta, anchor);
        if (headerTitle) {
          content = content
            .concat(new Delta().insert(headerTitle))
            .concat(new Delta().insert('\n'));
          return;
        }
      }
      content = content.concat(line).concat(new Delta().insert('\n'));
      return;
    }

    if (
      anchorHeaderId != null &&
      (anchorIndex == null || index <= anchorIndex)
    ) {
      return;
    }

    if (index > 1) {
      const lastOp = _.last(content.ops);
      if (
        typeof lastOp?.insert === 'string' &&
        !lastOp.insert.endsWith(' ') &&
        !lastOp.insert.endsWith('\n')
      ) {
        content = content.insert(' ');
      }
    }

    line.forEach((op) => {
      if (typeof op?.insert === 'string') {
        const opDelta = new Delta([{ insert: op.insert }]);
        content = content.concat(opDelta);
      }
    });
  });

  return content.insert('\n');
}

export default prepareContentForCard;
